// extracted by mini-css-extract-plugin
export default {"input":"mantineTextarea_input__r+QU8"};